import FileAttachmentLink from './FileAttachmentLink';

export default FileAttachmentLink;
